export const ACTIVE_SEASONS = 'activeSeasons';
export const MIN_DOSES_THRESHOLD = 'minDosesThreshold';
export const ORIGINAL_ORDER_CODE = 'originalOrderCode';
export const OLD_QUOTE_CODE = 'oldQuoteCode';
